import React from 'react';
import { motion } from 'framer-motion';
import { HiSearch, HiDocumentText, HiCog, HiLightningBolt } from 'react-icons/hi';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { HOW_IT_WORKS_STEPS } from '../utils/constants';

const iconComponents = {
  Search: HiSearch,
  FileText: HiDocumentText,
  Settings: HiCog,
  Rocket: HiLightningBolt,
};

const HowItWorks = () => {
  const { ref: sectionRef, isVisible: sectionVisible } = useScrollAnimation({ threshold: 0.1 });

  return (
    <section
      id="how-it-works"
      ref={sectionRef}
      style={{
        backgroundColor: '#FAF7F2',
        padding: 'clamp(4rem, 8vw, 7rem) 1.5rem',
        borderTop: '1px solid var(--color-border)',
      }}
    >
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={sectionVisible ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, ease: 'easeOut' }}
          style={{ textAlign: 'center', marginBottom: 'clamp(3rem, 5vw, 5rem)' }}
        >
          <h2 style={{
            fontSize: 'clamp(2rem, 4vw, 3rem)',
            fontWeight: 700,
            letterSpacing: '-0.02em',
            color: '#1A1A1A',
            marginBottom: '1rem',
            fontFamily: '"DM Sans", sans-serif',
          }}>
            From first call to live automation in 5 days
          </h2>
        </motion.div>

        {/* Steps */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr',
          gap: '0',
        }} className="steps-grid">
          {HOW_IT_WORKS_STEPS.map((step, index) => {
            const Icon = iconComponents[step.icon];
            return (
              <motion.div
                key={step.id}
                initial={{ opacity: 0, y: 15 }}
                animate={sectionVisible ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.5, delay: index * 0.1, ease: 'easeOut' }}
                style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '1.5rem',
                  padding: '1.5rem 0',
                  borderBottom: index < HOW_IT_WORKS_STEPS.length - 1 ? '1px solid var(--color-border)' : 'none',
                }}
              >
                {/* Step number */}
                <div style={{
                  flexShrink: 0,
                  width: '3rem',
                  height: '3rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: '#1A1A1A',
                  color: '#FFFFFF',
                  borderRadius: '12px',
                  fontWeight: 700,
                  fontSize: '1rem',
                  fontFamily: '"DM Sans", sans-serif',
                }}>
                  {step.id}
                </div>

                {/* Content */}
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.375rem' }}>
                    <h3 style={{
                      fontSize: '1.1rem',
                      fontWeight: 700,
                      color: '#1A1A1A',
                      fontFamily: '"DM Sans", sans-serif',
                    }}>
                      {step.title}
                    </h3>
                    {step.isFree && (
                      <span style={{
                        fontSize: '0.7rem',
                        fontWeight: 600,
                        padding: '2px 8px',
                        backgroundColor: '#1A1A1A',
                        color: '#FFFFFF',
                        borderRadius: '999px',
                        fontFamily: '"DM Sans", sans-serif',
                      }}>
                        FREE
                      </span>
                    )}
                  </div>
                  <p style={{
                    fontSize: '0.9rem',
                    lineHeight: 1.65,
                    color: '#666666',
                    fontFamily: '"DM Sans", sans-serif',
                  }}>
                    {step.description}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
